import api from "../api";
import { 
  login_endpoint, 
  auth_endpoint,
  dashboard_endpoint, 
  users_endpoint, 
  busOwners_endpoint, 
  drivers_endpoint, 
  conductors_endpoint,
  bookings_endpoint,
  customer_endpoints,
  coupons_endpoint,
  payment_endpoint,
    admin_profile_endpoint,
    commission_endpoint,
    influencers_endpoint,
route_endpoint,
admin_term_endpoint,
admin_layout_endpoint,
employee_endpoint,bus_endpoint,version_endpoint,viewRoutes_endpoint,
freelancer_endpoint,profit_endpoint,customerCare_endpoint, admin_expense_endpoint,master_route_endpoint,gst_endpoint,bookingPolicy_endpoint,booking_endpoint} from "../api_endpoints";

const { login_API } = login_endpoint;
const { getAllTerm } = admin_term_endpoint;
const { getAllLayout, getAllCategories } = admin_layout_endpoint;
const { dashboard_API } = dashboard_endpoint;
const { route_API } = route_endpoint;
const { users_API } = users_endpoint;
const { bookingFilter_API } = booking_endpoint;
const { 
  busOwners_API, 
  getBusOwnerById: getBusOwnerByIdEndpoint, 
  updateBusOwner: updateBusOwnerEndpoint,
  deleteBusOwner: deleteBusOwnerEndpoint ,
  approvedBusOwnerById : approvedBusOwnerById
} = busOwners_endpoint;
const { 
  addBusToOwnerApi 
} = busOwners_endpoint;
const { drivers_API } = drivers_endpoint;
const { conductors_API } = conductors_endpoint;

const { 
  getCustomers: customersEndpoint, 
  getCustomerById: getCustomerByIdEndpoint, 
  updateCustomer: updateCustomerEndpoint 
} = customer_endpoints;

const { 
  bookings_API,
  getBookingById: getBookingByIdEndpoint,
  updateBooking: updateBookingEndpoint,
  updateBookingStatus: updateBookingStatusEndpoint
} = bookings_endpoint;

const { 
  coupons_API,
  getCouponById: getCouponByIdEndpoint,
  updateCoupon: updateCouponEndpoint,
  deleteCoupon: deleteCouponEndpoint
} = coupons_endpoint;

const { 
  payments_API,
  getPaymentById: getPaymentByIdEndpoint,
  processPayment: processPaymentEndpoint,
  refundPayment: refundPaymentEndpoint
} = payment_endpoint;

const {
  getAdminProfile: getAdminProfileEndpoint,
  updateAdminProfile: updateAdminProfileEndpoint,
  changeAdminPassword: changeAdminPasswordEndpoint,
  updateAdminSettings: updateAdminSettingsEndpoint
} = admin_profile_endpoint;

const { 
  getCommissionReports: getCommissionReportsEndpoint,
  getBusOwnerCommission: getBusOwnerCommissionEndpoint,
  updateBusOwnerCommission: updateBusOwnerCommissionEndpoint,
  processCommissionPayout: processCommissionPayoutEndpoint,

  getInfluencerCommissionses: getInfluencerCommissionsEndpoint,
  getCommissionStats: getCommissionStatsEndpoint,
  getCommissionById: getCommissionByIdEndpoint,
  processBulkPayout: processBulkPayoutEndpoint,

  processCommissionPayment: processCommissionPaymentEndpoint 
} = commission_endpoint;

const { 
 influencers_API: influencers_API
} = influencers_endpoint;


const { 
  getBusIncome: getBusIncomeEndpoint, 
  getAllBusesIncome: getAllBusesIncomeEndpoint, 
  getBusIncomeSummary: getBusIncomeSummaryEndpoint
} = profit_endpoint;

const {
  employees_API,
  getEmployeeById: getEmployeeByIdEndpoint,
  updateEmployee: updateEmployeeEndpoint,
  toggleEmployeeStatus: toggleEmployeeStatusEndpoint, 
  deleteEmployee: deleteEmployeeEndpoint,
  permanentDeleteEmployee: permanentDeleteEmployeeEndpoint,
  bulkCreateEmployees: bulkCreateEmployeesEndpoint,
  updatePassword: updatePasswordEndpoint
} = employee_endpoint;

const {
  freelancers_API,
  getFreelancerById: getFreelancerByIdEndpoint,
  updateFreelancer: updateFreelancerEndpoint,
  deleteFreelancer: deleteFreelancerEndpoint,
  permanentDeleteFreelancer: permanentDeleteFreelancerEndpoint,
  bulkCreateFreelancers: bulkCreateFreelancersEndpoint,
  updatePassword: updateFreelancerPasswordEndpoint,
  approveFreelancer: approveFreelancerEndpoint,
  rejectFreelancer: rejectFreelancerEndpoint,
  toggleFreelancerStatus: toggleFreelancerStatusEndpoint,
  updatePermissions: updatePermissionsEndpoint,
  getFreelancerStats: getFreelancerStatsEndpoint
} = freelancer_endpoint;

const { 
  forgotPassword_API, 
  verifyOtp_API, 
  resetPassword_API, 
  resendOtp_API 
} = auth_endpoint;


const {
  bookingPolicies_API,
  getBookingPolicyById: getBookingPolicyByIdEndpoint,
  createBookingPolicy: createBookingPolicyEndpoint,
  updateBookingPolicy: updateBookingPolicyEndpoint,
  deleteBookingPolicy: deleteBookingPolicyEndpoint,
  permanentDeleteBookingPolicy: permanentDeleteBookingPolicyEndpoint,
  toggleBookingPolicyStatus: toggleBookingPolicyStatusEndpoint,
  getActiveBookingPolicy: getActiveBookingPolicyEndpoint,
  getFormattedPolicyText: getFormattedPolicyTextEndpoint,
  validateCancellation: validateCancellationEndpoint
} = bookingPolicy_endpoint;

export const toggleUserStatus = async (userId, token) => {
  try {
    // If your axios instance already attaches the token via interceptor,
    // you can drop the config entirely: await api.patch(toggleEmployeeStatusEndpoint(userId));
    const response = await api.patch(
      toggleEmployeeStatusEndpoint(userId),
      {}, // no body needed
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;   // axios response -> .data contains the payload
  } catch (error) {
    console.error('toggleUserStatus error:', error);
    throw error;
  }
};

export const getViewRoutes = async (token, params = {}) => {
  try {
    const response = await api.get(viewRoutes_endpoint.getViewRoutes, {
      headers: { 'Authorization': `Bearer ${token}` },
      params
    });
    return response.data;
  } catch (error) {
    console.error("GET_VIEW_ROUTES_ERROR:", error);
    throw error;
  }
};

/**
 * Get view route by ID
 */
export const getViewRouteById = async (id, token) => {
  try {
    const response = await api.get(viewRoutes_endpoint.getViewRouteById(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("GET_VIEW_ROUTE_BY_ID_ERROR:", error);
    throw error;
  }
};

/**
 * Get view route statistics
 */
export const getViewRouteStats = async (token) => {
  try {
    const response = await api.get(viewRoutes_endpoint.getViewRouteStats, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("GET_VIEW_ROUTE_STATS_ERROR:", error);
    throw error;
  }
};

/**
 * Deactivate view route (soft delete)
 */
export const deactivateViewRoute = async (id, token) => {
  try {
    const response = await api.delete(viewRoutes_endpoint.deactivateViewRoute(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("DEACTIVATE_VIEW_ROUTE_ERROR:", error);
    throw error;
  }
};

export const getVersions = async (token, params = {}) => {
  try {
    const response = await api.get(version_endpoint.versions_API, {
      headers: { 'Authorization': `Bearer ${token}` },
      params
    });
    return response.data;
  } catch (error) {
    console.error("GET_VERSIONS_API_ERROR:", error);
    throw error;
  }
};

export const getLatestVersions = async (platform = 'all') => {
  try {
    const response = await api.get(version_endpoint.latestVersions_API, {
      params: { platform }
    });
    return response.data;
  } catch (error) {
    console.error("GET_LATEST_VERSIONS_API_ERROR:", error);
    throw error;
  }
};

export const getLatestVersionByApp = async (appType, platform = 'all') => {
  try {
    const response = await api.get(version_endpoint.getLatestByApp(appType), {
      params: { platform }
    });
    return response.data;
  } catch (error) {
    console.error("GET_LATEST_VERSION_BY_APP_API_ERROR:", error);
    throw error;
  }
};

export const getVersionById = async (id, token) => {
  try {
    const response = await api.get(version_endpoint.getVersionById(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("GET_VERSION_BY_ID_API_ERROR:", error);
    throw error;
  }
};

export const createVersion = async (versionData, token) => {
  try {
    console.log("versionData :::: ",versionData)
    const response = await api.post(version_endpoint.createVersion, versionData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("CREATE_VERSION_API_ERROR:", error);
    throw error;
  }
};

export const updateVersion = async (id, versionData, token) => {
  try {
    const response = await api.put(version_endpoint.updateVersion(id), versionData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("UPDATE_VERSION_API_ERROR:", error);
    throw error;
  }
};

export const deleteVersion = async (id, token) => {
  try {
    const response = await api.delete(version_endpoint.deleteVersion(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("DELETE_VERSION_API_ERROR:", error);
    throw error;
  }
};

export const toggleVersionStatus = async (id, token) => {
  try {
    const response = await api.patch(version_endpoint.toggleVersionStatus(id), {}, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("TOGGLE_VERSION_STATUS_API_ERROR:", error);
    throw error;
  }
};

export const checkUpdateAvailable = async (appType, currentVersion, platform = 'all') => {
  try {
    const response = await api.post(version_endpoint.checkUpdate, {
      appType,
      currentVersion,
      platform
    });
    return response.data;
  } catch (error) {
    console.error("CHECK_UPDATE_API_ERROR:", error);
    throw error;
  }
};

export const getVersionStats = async (token) => {
  try {
    const response = await api.get(version_endpoint.versionStats, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("GET_VERSION_STATS_API_ERROR:", error);
    throw error;
  }
};

export const togglePayrollStatus = async (userId, status, token) => {
  try {
    console.log(`Toggling payroll status for user ${userId} to ${status}`);
    
    const response = await api.put(`/payroll/${userId}/toggle`, {
      status: status
    }, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log("Toggle Payroll Response:", response.data);
    return response.data;
  } catch (error) {
    console.error('Toggle payroll status error:', error);
    throw error;
  }
};

export const getCustomerCare = async (token) => {
  try {
    console.log("Fetching customer care details...");
    const response = await api.get(customerCare_endpoint.getCustomerCare, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Customer Care Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_CUSTOMER_CARE_API_ERROR..........", error);
    throw error;
  }
};

export const createCustomerCare = async (data, token) => {
  try {
    console.log("Creating customer care details...", data);
    const response = await api.post(customerCare_endpoint.createCustomerCare, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Create Customer Care Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("CREATE_CUSTOMER_CARE_API_ERROR..........", error);
    throw error;
  }
};

export const updateCustomerCare = async (id, data, token) => {
  try {
    console.log(`Updating customer care with ID: ${id}`, data);
    const response = await api.put(customerCare_endpoint.updateCustomerCare(id), data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Customer Care Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_CUSTOMER_CARE_API_ERROR..........", error);
    throw error;
  }
};

export const deleteCustomerCare = async (id, token) => {
  try {
    console.log(`Deleting customer care with ID: ${id}`);
    const response = await api.delete(customerCare_endpoint.deleteCustomerCare(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Delete Customer Care Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("DELETE_CUSTOMER_CARE_API_ERROR..........", error);
    throw error;
  }
};

export const toggleCustomerCareStatus = async (id, token) => {
  try {
    console.log(`Toggling customer care status for ID: ${id}`);
    const response = await api.patch(customerCare_endpoint.toggleCustomerCareStatus(id), {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Toggle Status Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("TOGGLE_CUSTOMER_CARE_STATUS_API_ERROR..........", error);
    throw error;
  }
};

export const getAllBusRouteSchedules = async (token, page = 1, limit = 10, search = '', filters = {}) => {
    try {
        const response = await api.get('/bus-route-schedules', {
            params: {
                page,
                limit,
                search,
                status: filters.status,
                busType: filters.busType,
                routeType: filters.routeType
            },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching bus route schedules:', error);
        throw error.response?.data || error;
    }
};

export const getBusRouteSchedule = async (busId, token) => {
    try {
        const response = await api.get(`/bus-route-schedule/${busId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching bus route schedule:', error);
        throw error.response?.data || error;
    }
};

export const updateBusRouteSchedule = async (busId, updateData, token) => {
    try {
        const response = await api.put(`/bus-route-schedule/${busId}`, updateData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating bus route schedule:', error);
        throw error.response?.data || error;
    }
};

export const updateSpecificRouteSchedule = async (busId, routeId, updateData, token) => {
    try {
        const response = await api.put(`/bus-route-schedule/${busId}/route/${routeId}`, updateData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating specific route schedule:', error);
        throw error.response?.data || error;
    }
};

export const getPointDisabledDates = async (busId, pointId, token) => {
    try {
        const response = await api.get(`/bus-route-schedule/${busId}/point/${pointId}/disabled-dates`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching disabled dates:', error);
        throw error.response?.data || error;
    }
};


export const getBusById = async (busId, token) => {
  try {
    const response = await api.get(bus_endpoint.getBusById(busId), {
      headers: { Authorization: `Bearer ${token}` }
    });
    console.log('getBusById response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching bus by ID:', error);
    console.error('Error response:', error.response?.data);
    console.error('Error status:', error.response?.status);
    throw error;
  }
};

export const activateBusWithPlatformFee = async (busId, platformFeeData, token) => {
  try {
    const response = await api.put(
      `/bus/activate/${busId}`,
      platformFeeData,
      {
        headers: { 'Authorization': `Bearer ${token}` }
      }
    );
    console.log('activateBusWithPlatformFee response:', response.data);
    return response.data;
  } catch (error) {
    console.error('ACTIVATE_BUS_WITH_PLATFORM_FEE_ERROR:', error);
    console.error('Error config:', error.config);
    console.error('Error response:', error.response);
    throw error;
  }
};

export const searchMasterRouteIntermediateStops = async (token, searchQuery) => {
  try {
    const response = await api.get(
      `/cities/route/search?q=${encodeURIComponent(searchQuery)}`,
      {
        headers: { 'Authorization': `Bearer ${token}` }
      }
    );
    console.log('searchMasterRouteIntermediateStops response:', response.data);
    return response.data;
  } catch (error) {
    console.error('SEARCH_MASTER_ROUTE_INTERMEDIATE_STOPS_ERROR:', error);
    console.error('Error config:', error.config);
    console.error('Error response:', error.response);
    throw error;
  }
};

export const searchRouteIntermediateStops = async (token, searchQuery) => {
  try {
    const response = await api.get(
      `/cities/masterroute/search?q=${encodeURIComponent(searchQuery)}`,
      {
        headers: { 'Authorization': `Bearer ${token}` }
      }
    );
    console.log('searchRouteIntermediateStops response:', response.data);
    return response.data;
  } catch (error) {
    console.error('SEARCH_ROUTE_INTERMEDIATE_STOPS_ERROR:', error);
    console.error('Error config:', error.config);
    console.error('Error response:', error.response);
    throw error;
  }
};

export const getBookingPolicies = async (token, page = 1, limit = 10, searchTerm = '', isActive = null) => {
  try {
    let url = `${bookingPolicies_API}?page=${page}&limit=${limit}`;
    if (searchTerm) url += `&search=${searchTerm}`;
    if (isActive !== null) url += `&isActive=${isActive}`;
    
    const response = await api.get(url, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('GET_BOOKING_POLICIES_ERROR:', error);
    throw error;
  }
};

export const getBookingPolicyById = async (id, token) => {
  try {
    const response = await api.get(getBookingPolicyByIdEndpoint(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('GET_BOOKING_POLICY_BY_ID_ERROR:', error);
    throw error;
  }
};

export const createBookingPolicy = async (policyData, token) => {
  try {
    const response = await api.post(createBookingPolicyEndpoint, policyData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('CREATE_BOOKING_POLICY_ERROR:', error);
    throw error;
  }
};

export const updateBookingPolicy = async (id, policyData, token) => {
  try {
    const response = await api.put(updateBookingPolicyEndpoint(id), policyData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('UPDATE_BOOKING_POLICY_ERROR:', error);
    throw error;
  }
};

export const deleteBookingPolicy = async (id, token) => {
  try {
    const response = await api.delete(deleteBookingPolicyEndpoint(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('DELETE_BOOKING_POLICY_ERROR:', error);
    throw error;
  }
};

export const permanentDeleteBookingPolicy = async (id, token) => {
  try {
    const response = await api.delete(permanentDeleteBookingPolicyEndpoint(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('PERMANENT_DELETE_BOOKING_POLICY_ERROR:', error);
    throw error;
  }
};

export const toggleBookingPolicyStatus = async (id, token) => {
  try {
    const response = await api.patch(toggleBookingPolicyStatusEndpoint(id), {}, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('TOGGLE_BOOKING_POLICY_STATUS_ERROR:', error);
    throw error;
  }
};

export const getActiveBookingPolicy = async () => {
  try {
    const response = await api.get(getActiveBookingPolicyEndpoint);
    return response.data;
  } catch (error) {
    console.error('GET_ACTIVE_BOOKING_POLICY_ERROR:', error);
    throw error;
  }
};

export const getFormattedPolicyText = async (id, token) => {
  try {
    const response = await api.get(getFormattedPolicyTextEndpoint(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('GET_FORMATTED_POLICY_TEXT_ERROR:', error);
    throw error;
  }
};

export const validateCancellation = async (departureDateTime, policyId = null) => {
  try {
    const response = await api.post(validateCancellationEndpoint, {
      departureDateTime,
      policyId
    });
    return response.data;
  } catch (error) {
    console.error('VALIDATE_CANCELLATION_ERROR:', error);
    throw error;
  }
};

export const getCurrentPlatformFee = async (token) => {
  try {
    const response = await api.get('/platform-fees/current', {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('GET_CURRENT_PLATFORM_FEE_ERROR:', error);
    throw error;
  }
};

export const getPlatformFees = async (token, page = 1, limit = 10, filters = {}) => {
  try {
    const params = { page, limit, ...filters };
    const response = await api.get('/platform-fees', {
      params,
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('GET_PLATFORM_FEES_ERROR:', error);
    throw error;
  }
};

export const getPlatformFeeById = async (id, token) => {
  try {
    const response = await api.get(`/platform-fees/${id}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('GET_PLATFORM_FEE_BY_ID_ERROR:', error);
    throw error;
  }
};

export const createPlatformFee = async (data, token) => {
  try {
    const response = await api.post('/platform-fees', data, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('CREATE_PLATFORM_FEE_ERROR:', error);
    throw error;
  }
};

export const updatePlatformFee = async (id, data, token) => {
  try {
    const response = await api.put(`/platform-fees/${id}`, data, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('UPDATE_PLATFORM_FEE_ERROR:', error);
    throw error;
  }
};

export const deletePlatformFee = async (id, token) => {
  try {
    const response = await api.delete(`/platform-fees/${id}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('DELETE_PLATFORM_FEE_ERROR:', error);
    throw error;
  }
};

export const calculatePlatformFee = async (amount, bookingType, token) => {
  try {
    const response = await api.post('/platform-fees/calculate', 
      { amount, bookingType },
      { headers: { 'Authorization': `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('CALCULATE_PLATFORM_FEE_ERROR:', error);
    throw error;
  }
};

export const getPlatformFeeStats = async (token) => {
  try {
    const response = await api.get('/platform-fees/stats', {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('GET_PLATFORM_FEE_STATS_ERROR:', error);
    throw error;
  }
};


export const getGSTR1 = async (month, year, quarter = null, token) => {
  try {
    const params = { year };
    if (month) params.month = month;
    if (quarter) params.quarter = quarter;
    
    const response = await api.get(gst_endpoint.gstr1, { 
      params,
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Get GSTR-1 error:', error);
    throw error;
  }
};

export const downloadGSTR1CSV = async (month, year, quarter = null, token) => {
  try {
    const params = { year };
    if (month) params.month = month;
    if (quarter) params.quarter = quarter;
    
    const response = await api.get(gst_endpoint.gstr1CSV, { 
      params,
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Download GSTR-1 CSV error:', error);
    throw error;
  }
};

export const downloadGSTR1PDF = async (month, year, quarter = null, token) => {
  try {
    const params = { year };
    if (month) params.month = month;
    if (quarter) params.quarter = quarter;
    
    const response = await api.get(gst_endpoint.gstr1PDF, { 
      params,
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Download GSTR-1 PDF error:', error);
    throw error;
  }
};

export const getGSTR3B = async (month, year, quarter = null, token) => {
  try {
    const params = { year };
    if (month) params.month = month;
    if (quarter) params.quarter = quarter;
    
    const response = await api.get(gst_endpoint.gstr3b, { 
      params,
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Get GSTR-3B error:', error);
    throw error;
  }
};

export const downloadGSTR3BCSV = async (month, year, quarter = null, token) => {
  try {
    const params = { year };
    if (month) params.month = month;
    if (quarter) params.quarter = quarter;
    
    const response = await api.get(gst_endpoint.gstr3bCSV, { 
      params,
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Download GSTR-3B CSV error:', error);
    throw error;
  }
};

export const downloadGSTR3BPDF = async (month, year, quarter = null, token) => {
  try {
    const params = { year };
    if (month) params.month = month;
    if (quarter) params.quarter = quarter;
    
    const response = await api.get(gst_endpoint.gstr3bPDF, { 
      params,
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Download GSTR-3B PDF error:', error);
    throw error;
  }
};

export const getGSTDashboard = async (year, token) => {
  try {
    const response = await api.get(gst_endpoint.dashboard, { 
      params: { year },
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Get GST Dashboard error:', error);
    throw error;
  }
};

export const getGSTInvoices = async (page = 1, limit = 20, filters = {}, token) => {
  try {
    const params = { page, limit, ...filters };
    const response = await api.get(gst_endpoint.invoices, { 
      params,
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Get GST Invoices error:', error);
    throw error;
  }
};

export const getGSTInvoiceById = async (id, token) => {
  try {
    const response = await api.get(gst_endpoint.invoiceById(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Get GST Invoice by ID error:', error);
    throw error;
  }
};

export const generateGSTInvoices = async (month, year, token) => {
  try {
    const response = await api.post(gst_endpoint.generateInvoices, 
      { month, year },
      { headers: { 'Authorization': `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Generate GST Invoices error:', error);
    throw error;
  }
};

export const cancelGSTInvoice = async (id, reason, token) => {
  try {
    const response = await api.post(gst_endpoint.cancelInvoice(id), 
      { reason },
      { headers: { 'Authorization': `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Cancel GST Invoice error:', error);
    throw error;
  }
};

export const getGSTRates = async (filters = {}, token) => {
  try {
    console.log("token ::::::::: ",token)
    const response = await api.get(gst_endpoint.gstRates_API, { 
      params: filters,
      headers: { 'Authorization': `Bearer ${token}` }
    });
    console.log("response1 :::::::::::: ",response)
    return response.data;
  } catch (error) {
    console.error('Get GST Rates error:', error);
    throw error;
  }
};

export const createGSTRate = async (rateData, token) => {
  try {
    const response = await api.post(gst_endpoint.gstRates_API, rateData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Create GST Rate Error:", error);
    throw error;
  }
};

export const updateGSTRate = async (id, rateData, token) => {
  try {
    const response = await api.put(gst_endpoint.updateGSTRate(id), rateData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Update GST Rate Error:", error);
    throw error;
  }
};

export const deleteGSTRate = async (id, token) => {
  try {
    const response = await api.delete(gst_endpoint.deleteGSTRate(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Delete GST Rate Error:", error);
    throw error;
  }
};

export const getGSTRateById = async (id, token) => {
  try {
    const response = await api.get(gst_endpoint.getGSTRateById(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Get GST Rate By ID Error:", error);
    throw error;
  }
};

export const getAllGSTRates = async (filters = {}, token) => {
  try {
    
    const { page = 1, limit = 50, taxType, serviceType, isActive } = filters;
    const params = { page, limit };
    if (taxType) params.taxType = taxType;
    if (serviceType) params.serviceType = serviceType;
    if (isActive !== undefined) params.isActive = isActive;
    console.log("token :::::::::: ",token)
    const response = await api.get(gst_endpoint.gstRates_API, {
      headers: { 'Authorization': `Bearer ${token}` },
      params
    });
    console.log("response :::::::::: ",response)
    return response.data;
  } catch (error) {
    console.error("Get All GST Rates Error:", error);
    throw error;
  }
};

export const getActiveGSTRates = async (token, serviceType = null) => {
  try {
    const params = serviceType ? { serviceType } : {};
    const response = await api.get(gst_endpoint.getActiveGSTRates, {
      headers: { 'Authorization': `Bearer ${token}` },
      params
    });
    return response.data;
  } catch (error) {
    console.error("Get Active GST Rates Error:", error);
    throw error;
  }
};

export const bulkCreateGSTRates = async (rates, token) => {
  try {
    const response = await api.post(gst_endpoint.bulkCreateGSTRates, { rates }, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Bulk Create GST Rates Error:", error);
    throw error;
  }
};

export const bulkUpdateGSTRates = async (updates, token) => {
  try {
    const response = await api.put(gst_endpoint.bulkUpdateGSTRates, { updates }, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Bulk Update GST Rates Error:", error);
    throw error;
  }
};

export const getGSTConfig = async (token) => {
  try {
    const response = await api.get(gst_endpoint.getGSTConfig, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Get GST Config Error:", error);
    throw error;
  }
};

export const updateGSTConfig = async (configData, token) => {
  try {
    const response = await api.put(gst_endpoint.updateGSTConfig, configData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Update GST Config Error:", error);
    throw error;
  }
};

export const calculateGST = async (calculationData, token) => {
  try {
    const response = await api.post(gst_endpoint.calculateGST, calculationData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Calculate GST Error:", error);
    throw error;
  }
};

export const getCurrentRatesForService = async (serviceType, token, date = null) => {
  try {
    const params = date ? { date } : {};
    const response = await api.get(gst_endpoint.getCurrentRates(serviceType), {
      headers: { 'Authorization': `Bearer ${token}` },
      params
    });
    return response.data;
  } catch (error) {
    console.error("Get Current Rates Error:", error);
    throw error;
  }
};

export const getGSTRateHistory = async (token, filters = {}) => {
  try {
    const { serviceType, taxType, startDate, endDate } = filters;
    const params = {};
    if (serviceType) params.serviceType = serviceType;
    if (taxType) params.taxType = taxType;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    
    const response = await api.get(gst_endpoint.getGSTRateHistory, {
      headers: { 'Authorization': `Bearer ${token}` },
      params
    });
    return response.data;
  } catch (error) {
    console.error("Get GST Rate History Error:", error);
    throw error;
  }
};

export const getGSTSummary = async (token) => {
  try {
    const response = await api.get(gst_endpoint.getGSTSummary, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Get GST Summary Error:", error);
    throw error;
  }
};

export const getAllMasterRoutes = async (token, page = 1, limit = 10, search = "", filters = {}) => {
  try {
    const queryParams = new URLSearchParams({
      page,
      limit,
      ...(search && { search }),
      ...(filters.source && { source: filters.source }),
      ...(filters.destination && { destination: filters.destination }),
      ...(filters.isActive !== undefined && { isActive: filters.isActive }),
      ...(filters.isRoundTrip !== undefined && { isRoundTrip: filters.isRoundTrip }),
      ...(filters.creatorType && { creatorType: filters.creatorType }),
      ...(filters.busOwner && { busOwner: filters.busOwner })
    });
    
    const response = await api.get(`/master-routes?${queryParams}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching master routes:", error);
    throw error;
  }
};

export const searchMasterRoutesBySourceDestination = async (token, source, destination) => {
  try {
    const response = await api.get(`/master-routes/search`, {
      params: { source, destination },
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Error searching master routes:", error);
    throw error;
  }
};

export const getMasterRouteById = async (routeId, token) => {
  try {
    const response = await api.get(master_route_endpoint.getMasterRouteById(routeId), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching master route:', error);
    throw error;
  }
};

export const createMasterRoute = async (routeData, token) => {
  try {
    const response = await api.post(master_route_endpoint.masterRoutes_API, routeData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating master route:', error);
    throw error;
  }
};

export const updateMasterRoute = async (routeId, routeData, token) => {
  try {
    const response = await api.put(master_route_endpoint.updateMasterRoute(routeId), routeData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating master route:', error);
    throw error;
  }
};

export const deleteMasterRoute = async (routeId, token) => {
  try {
    const response = await api.delete(master_route_endpoint.deleteMasterRoute(routeId), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting master route:', error);
    throw error;
  }
};

export const toggleMasterRouteStatus = async (routeId, isActive, token) => {
  try {
    const response = await api.patch(master_route_endpoint.toggleMasterRouteStatus(routeId), 
      { isActive },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error toggling master route status:', error);
    throw error;
  }
};

export const searchMasterRoutesByCitiesForForm = async (token, query, type = 'both') => {
  try {
    const response = await api.get(
      `/master-routes/source-destination-cities?query=${encodeURIComponent(query)}&type=${type}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error searching cities:", error);
    return { success: false, data: { suggestions: [] } };
  }
};

export const searchMasterRoutesByCities = async (token, source = '', destination = '') => {
  try {
    const params = {};
    if (source && source.trim()) params.source = source;
    if (destination && destination.trim()) params.destination = destination;
    
    console.log('Calling API with params:', params);
    console.log('API URL:', master_route_endpoint.searchMasterRoutesByCities);
    
    const response = await api.get(master_route_endpoint.searchMasterRoutesByCities, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      params
    });
    console.log('API Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error searching master routes by cities:', error);
    console.error('Error response:', error.response);
    throw error;
  }
};
export const getAdminExpenses = async (params, token) => {
  try {
    const response = await api.get(admin_expense_endpoint.adminExpenses_API, {
      params: params,
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("GET_ADMIN_EXPENSES_API_ERROR..........", error);
    throw error;
  }
};

export const getAdminExpenseById = async (id, token) => {
  try {
    const response = await api.get(admin_expense_endpoint.getAdminExpenseById(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("GET_ADMIN_EXPENSE_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const createAdminExpense = async (expenseData, token) => {
  try {
    const response = await api.post(admin_expense_endpoint.adminExpenses_API, expenseData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("CREATE_ADMIN_EXPENSE_API_ERROR..........", error);
    throw error;
  }
};

export const updateAdminExpense = async (id, expenseData, token) => {
  try {
    const response = await api.put(admin_expense_endpoint.updateAdminExpense(id), expenseData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("UPDATE_ADMIN_EXPENSE_API_ERROR..........", error);
    throw error;
  }
};

export const deleteAdminExpense = async (id, token) => {
  try {
    const response = await api.delete(admin_expense_endpoint.deleteAdminExpense(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("DELETE_ADMIN_EXPENSE_API_ERROR..........", error);
    throw error;
  }
};

export const approveAdminExpense = async (id, approvalData, token) => {
  try {
    const response = await api.patch(admin_expense_endpoint.approveAdminExpense(id), approvalData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("APPROVE_ADMIN_EXPENSE_API_ERROR..........", error);
    throw error;
  }
};

export const getAdminExpenseCategories = async (token) => {
  try {
    const response = await api.get(admin_expense_endpoint.getAdminExpenseCategories, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("GET_ADMIN_EXPENSE_CATEGORIES_API_ERROR..........", error);
    throw error;
  }
};

export const getAdminExpenseDepartments = async (token) => {
  try {
    const response = await api.get(admin_expense_endpoint.getAdminExpenseDepartments, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("GET_ADMIN_EXPENSE_DEPARTMENTS_API_ERROR..........", error);
    throw error;
  }
};

export const getAdminExpenseStats = async (params, token) => {
  try {
    const response = await api.get(admin_expense_endpoint.getAdminExpenseStats, {
      params: params,
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("GET_ADMIN_EXPENSE_STATS_API_ERROR..........", error);
    throw error;
  }
};


export const getBusIncome = async (busId, params, token) => {
  try {
    console.log("Fetching bus income with params:", params);
    const response = await api.get(getBusIncomeEndpoint(busId), {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Bus Income API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_BUS_INCOME_API_ERROR..........", error);
    throw error;
  }
};

export const getAllBusesIncome = async (params, token) => {
  try {
    console.log("Fetching all buses income with params:", params);
    const response = await api.get(getAllBusesIncomeEndpoint, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("All Buses Income API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_ALL_BUSES_INCOME_API_ERROR..........", error);
    throw error;
  }
};

export const getBusIncomeSummary = async (params, token) => {
  try {
    console.log("Fetching bus income summary with params:", params);
    const response = await api.get(getBusIncomeSummaryEndpoint, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Bus Income Summary API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_BUS_INCOME_SUMMARY_API_ERROR..........", error);
    throw error;
  }
};

export const processCommissionPayment = async (ownerId, paymentData, token) => {
  try {
    const url = processCommissionPaymentEndpoint(ownerId); 
    
    const response = await api.post(url, paymentData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getCommissionPaymentHistory = async (ownerId, token, page = 1, limit = 10) => {
  try {
    const url = commission_endpoint.getCommissionPaymentHistory(ownerId);
    console.log('Get Payment History URL:', url);
    
    const response = await api.get(url, {
      params: { page, limit },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Get Payment History Error:', error);
    throw error.response?.data || error.message;
  }
};

export const getAllCommissionPayments = async (token, filters = {}) => {
  try {
    const url = commission_endpoint.getAllCommissionPayments;
    console.log('Get All Payments URL:', url);
    
    const response = await api.get(url, {
      params: filters,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Get All Payments Error:', error);
    throw error.response?.data || error.message;
  }
};

export const updatePaymentStatus = async (paymentId, status, token) => {
  try {
    const url = commission_endpoint.updatePaymentStatus(paymentId);
    console.log('Update Payment Status URL:', url);
    
    const response = await api.put(url, 
      { status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Update Payment Status Error:', error);
    throw error.response?.data || error.message;
  }
};

export const getFreelancers = async (token, page = 1, limit = 10, search = '', status = '', approval = '') => {
  try {
    let url = `${freelancers_API}?page=${page}&limit=${limit}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (status) url += `&status=${status}`;
    if (approval) url += `&approval=${approval}`;
    
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching freelancers:', error);
    throw error;
  }
};

export const getFreelancerById = async (freelancerId, token) => {
  try {
    const url = typeof getFreelancerByIdEndpoint === 'function' 
      ? getFreelancerByIdEndpoint(freelancerId) 
      : `${freelancers_API}/${freelancerId}`;
    
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching freelancer by ID:', error);
    throw error;
  }
};

export const createFreelancer = async (freelancerData, token) => {
  try {
    const response = await api.post(freelancers_API, freelancerData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating freelancer:', error);
    throw error;
  }
};

export const updateFreelancer = async (freelancerId, updateData, token) => {
  try {
    const url = typeof updateFreelancerEndpoint === 'function'
      ? updateFreelancerEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}`;
    
    const response = await api.put(url, updateData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating freelancer:', error);
    throw error;
  }
};

export const updateFreelancerPassword = async (freelancerId, passwordData, token) => {
  try {
    const url = typeof updateFreelancerPasswordEndpoint === 'function'
      ? updateFreelancerPasswordEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}/reset-password`;
    
    const response = await api.post(url, passwordData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating freelancer password:', error);
    throw error;
  }
};

export const deleteFreelancer = async (freelancerId, token) => {
  try {
    const url = typeof deleteFreelancerEndpoint === 'function'
      ? deleteFreelancerEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}`;
    
    const response = await api.delete(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting freelancer:', error);
    throw error;
  }
};

export const permanentDeleteFreelancer = async (freelancerId, token) => {
  try {
    const url = typeof permanentDeleteFreelancerEndpoint === 'function'
      ? permanentDeleteFreelancerEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}/permanent`;
    
    const response = await api.delete(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error permanently deleting freelancer:', error);
    throw error;
  }
};

export const bulkCreateFreelancers = async (freelancersData, token) => {
  try {
    const response = await api.post(bulkCreateFreelancersEndpoint, { freelancers: freelancersData }, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error bulk creating freelancers:', error);
    throw error;
  }
};

export const approveFreelancer = async (freelancerId, token) => {
  try {
    const url = typeof approveFreelancerEndpoint === 'function'
      ? approveFreelancerEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}/approve`;
    
    const response = await api.patch(url, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error approving freelancer:', error);
    throw error;
  }
};

export const rejectFreelancer = async (freelancerId, token) => {
  try {
    const url = typeof rejectFreelancerEndpoint === 'function'
      ? rejectFreelancerEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}/reject`;
    
    const response = await api.patch(url, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error rejecting freelancer:', error);
    throw error;
  }
};

export const toggleFreelancerStatus = async (freelancerId, token) => {
  try {
    const url = typeof toggleFreelancerStatusEndpoint === 'function'
      ? toggleFreelancerStatusEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}/toggle-status`;
    
    const response = await api.patch(url, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error toggling freelancer status:', error);
    throw error;
  }
};

export const updateFreelancerPermissions = async (freelancerId, permissions, token) => {
  try {
    const url = typeof updatePermissionsEndpoint === 'function'
      ? updatePermissionsEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}/permissions`;
    
    const response = await api.put(url, { permissions }, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating freelancer permissions:', error);
    throw error;
  }
};

export const getFreelancerStats = async (token) => {
  try {
    const response = await api.get(getFreelancerStatsEndpoint, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching freelancer stats:', error);
    throw error;
  }
};

export const getEmployees = async (token, page = 1, limit = 10, search = '', role = '', department = '', status = '') => {
  try {
    let url = `${employees_API}?page=${page}&limit=${limit}&search=${search}`;
    if (role) url += `&role=${role}`;
    if (department) url += `&department=${department}`;
    if (status) url += `&isActive=${status === 'active'}`;
    
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching employees:', error);
    throw error;
  }
};

export const getEmployeeById = async (employeeId, token) => {
  try {
    const url = typeof getEmployeeByIdEndpoint === 'function' 
      ? getEmployeeByIdEndpoint(employeeId) 
      : `${employees_API}/${employeeId}`;
    
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching employee by ID:', error);
    throw error;
  }
};

export const createEmployee = async (employeeData, token) => {
  try {
    const response = await api.post(employees_API, employeeData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating employee:', error);
    throw error;
  }
};

export const updateEmployee = async (employeeId, updateData, token) => {
  try {
    const cleanData = { ...updateData };
    
    delete cleanData._id;
    delete cleanData.id;
    delete cleanData.serialNo;
    delete cleanData.createdAt;
    delete cleanData.updatedAt;
    delete cleanData.__v;
    delete cleanData.status;
    delete cleanData.mobileNumber;
    
    if (cleanData.payroll) {
      if (cleanData.payroll.salary) {
        Object.keys(cleanData.payroll.salary).forEach(key => {
          const value = cleanData.payroll.salary[key];
          if (typeof value === 'string' && !isNaN(value)) {
            cleanData.payroll.salary[key] = parseFloat(value);
          }
        });
      }
      
      Object.keys(cleanData.payroll).forEach(key => {
        if (cleanData.payroll[key] === '') {
          cleanData.payroll[key] = null;
        }
      });
      
      const nestedObjects = ['bankDetails', 'taxDetails'];
      nestedObjects.forEach(objName => {
        if (cleanData.payroll[objName]) {
          Object.keys(cleanData.payroll[objName]).forEach(key => {
            if (cleanData.payroll[objName][key] === '') {
              cleanData.payroll[objName][key] = null;
            }
          });
        }
      });
    }

    if (cleanData.phoneNumber) {
      cleanData.phone = cleanData.phoneNumber;
    }

    console.log('Sending update data:', JSON.stringify(cleanData, null, 2));

    const url = typeof updateEmployeeEndpoint === 'function'
      ? updateEmployeeEndpoint(employeeId)
      : `${employees_API}/${employeeId}`;
    
    const response = await api.put(url, cleanData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error updating employee:', error);
    
    if (error.response) {
      console.error('Response status:', error.response.status);
      console.error('Response data:', error.response.data);
      console.error('Response headers:', error.response.headers);
    }
    
    throw error;
  }
};

export const updateEmployeePassword = async (employeeId, passwordData, token) => {
  try {
    const url = typeof updatePasswordEndpoint === 'function'
      ? updatePasswordEndpoint(employeeId)
      : `${employees_API}/${employeeId}/password`;
    
    const response = await api.put(url, passwordData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating employee password:', error);
    throw error;
  }
};

export const deleteEmployee = async (employeeId, token) => {
  try {
    const url = typeof deleteEmployeeEndpoint === 'function'
      ? deleteEmployeeEndpoint(employeeId)
      : `${employees_API}/${employeeId}`;
    
    const response = await api.delete(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting employee:', error);
    throw error;
  }
};

export const permanentDeleteEmployee = async (employeeId, token) => {
  try {
    const url = typeof permanentDeleteEmployeeEndpoint === 'function'
      ? permanentDeleteEmployeeEndpoint(employeeId)
      : `${employees_API}/${employeeId}/permanent`;
    
    const response = await api.delete(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error permanently deleting employee:', error);
    throw error;
  }
};

export const bulkCreateEmployees = async (employeesData, token) => {
  try {
    const response = await api.post(bulkCreateEmployeesEndpoint, { employees: employeesData }, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error bulk creating employees:', error);
    throw error;
  }
};

export const getBusRoutes = async (token, page = 1, limit = 10, search = '', ownerId = null) => {
  try {
    let url = `${route_API}?page=${page}&limit=${limit}&search=${search}`;
    if (ownerId) {
      url += `&ownerId=${ownerId}`;
    }
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching bus routes:', error);
    throw error;
  }
};

export const deleteBus = async (busId, token) => {
  try {
    const response = await api.delete(`/buses/${busId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting bus:', error);
    throw error;
  }
};

export const updateBus = async (busId, formData, token) => {
  try {
    const response = await api.put(`/buses/${busId}`, formData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating bus:', error);
    throw error;
  }
};

export const updatePendingBus = async (busId, formData, token) => {
  try {
    const response = await api.put(`/pending/bus/${busId}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating pending bus:', error);
    throw error;
  }
};

export const getAllBuses = async (token, params = {}) => {
  try {
    const { page = 1, limit = 10, search = '', busType = '', busCategory = '', status = '' } = params;
    let url = `/buses?page=${page}&limit=${limit}&search=${search}&busType=${busType}&busCategory=${busCategory}&status=${status}`;
    
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching all buses:', error);
    throw error;
  }
};

export const getBusStats = async (token) => {
  try {
    const response = await api.get('/buses/stats', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching bus stats:', error);
    throw error;
  }
};

export const deleteDriver = async (driverId, token) => {
  try {
    const response = await api.delete(
      `${drivers_API}/${driverId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting driver:', error);
    throw error;
  }
};

export const deleteConductor = async (conductorId, token) => {
  try {
    const response = await api.delete(
      `${conductors_API}/${conductorId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting conductor:', error);
    throw error;
  }
};


export const getAllDrivers = async (token, page = 1, limit = 10, search = '') => {
  try {
    const response = await api.get(`${drivers_endpoint.drivers_API}?page=${page}&limit=${limit}&search=${search}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching drivers:', error);
    throw error;
  }
};

export const addDriver = async (driverData, token) => {
  try {
    const response = await api.post(
      drivers_API,
      driverData,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error adding driver:', error);
    throw error;
  }
};

export const addConductor = async (conductorData, token) => {
  try {
    const response = await api.post(
      conductors_API,
      conductorData,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error adding conductor:', error);
    throw error;
  }
};


export const getDriversByBusOwner = async (busOwnerId, token, params = {}) => {
  try {
    const { page = 1, limit = 10, assigned, search } = params;
    let url = `${drivers_API}/busowner/${busOwnerId}?page=${page}&limit=${limit}`;
    if (assigned !== undefined) url += `&assigned=${assigned}`;
    if (search) url += `&search=${search}`;
    
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching drivers by bus owner:', error);
    throw error;
  }
};

export const assignDriverToBus = async (driverId, busId, busOwnerId, token) => {
  try {
    const response = await api.post(
      `${drivers_API}/${driverId}/assign/${busId}`,
      { busOwnerId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error assigning driver to bus:', error);
    throw error;
  }
};

export const unassignDriverFromBus = async (driverId, busOwnerId, token) => {
  try {
    const response = await api.post(
      `${drivers_API}/${driverId}/unassign`,
      { busOwnerId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error unassigning driver from bus:', error);
    throw error;
  }
};

export const getAllConductors = async (token, page = 1, limit = 10, search = '') => {
  try {
    const response = await api.get(`${conductors_endpoint.conductors_API}?page=${page}&limit=${limit}&search=${search}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching conductors:', error);
    throw error;
  }
};

export const getConductorsByBusOwner = async (busOwnerId, token, params = {}) => {
  try {
    const { page = 1, limit = 10, assigned, search } = params;
    let url = `${conductors_API}/busowner/${busOwnerId}?page=${page}&limit=${limit}`;
    if (assigned !== undefined) url += `&assigned=${assigned}`;
    if (search) url += `&search=${search}`;
    
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching conductors by bus owner:', error);
    throw error;
  }
};

export const assignConductorToBus = async (conductorId, busId, busOwnerId, token) => {
  try {
    const response = await api.post(
      `${conductors_API}/${conductorId}/assign/${busId}`,
      { busOwnerId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error assigning conductor to bus:', error);
    throw error;
  }
};

export const unassignConductorFromBus = async (conductorId, busOwnerId, token) => {
  try {
    const response = await api.post(
      `${conductors_API}/${conductorId}/unassign`,
      { busOwnerId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error unassigning conductor from bus:', error);
    throw error;
  }
};

export const getAvailableDrivers = async (busOwnerId, token, search = '') => {
  try {
    const response = await api.get(
      `${conductors_API}/busowner/${busOwnerId}?assigned=false&search=${search}&limit=50`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching available drivers:', error);
    throw error;
  }
};

export const getAvailableConductors = async (busOwnerId, token, search = '') => {
  try {
    const response = await api.get(
      `${conductors_API}/busowner/${busOwnerId}?assigned=false&search=${search}&limit=50`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching available conductors:', error);
    throw error;
  }
};

export const getAllCategory = async (token, busCategory = null) => {
  try {
    let url = '/categories';
    if (busCategory) {
      url += `?busCategory=${encodeURIComponent(busCategory)}`;
    }
    
    const response = await api.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

export const getSeatLayoutsByBustype = async (bustype, token) => {
  try {
    const response = await api.get(`/layouts/bustype/${bustype}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching seat layouts:', error);
    throw error;
  }
};


export const getSeatLayouts = async (busType, token) => {
  try {
    console.log('Fetching seat layouts for bus type:', busType);
   
    const url = admin_layout_endpoint.getLayoutsByBusType(busType);
    
    console.log('Request URL:', url);
    
    const response = await api.get(url, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error fetching seat layouts:', error);
    console.error('Error details:', error.response?.data || error.message);
    
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to fetch seat layouts',
      data: []
    };
  }
};


export const forgotPassword = async (email) => {
  try {
    const response = await api.post(forgotPassword_API, { email });
    return response.data;
  } catch (error) {
    console.error('Forgot password error:', error);
    throw error.response?.data || error;
  }
};

export const verifyOtp = async (email, otp) => {
  try {
    const response = await api.post(verifyOtp_API, { email, otp });
    return response.data;
  } catch (error) {
    console.error('Verify OTP error:', error);
    throw error.response?.data || error;
  }
};

export const resetPassword = async (resetToken, email, password, confirmPassword) => {
  try {
    const response = await api.post(resetPassword_API, {
      resetToken,
      email,
      password,
      confirmPassword
    });
    return response.data;
  } catch (error) {
    console.error('Reset password error:', error);
    throw error.response?.data || error;
  }
};

export const resendOtp = async (email) => {
  try {
    const response = await api.post(resendOtp_API, { email });
    return response.data;
  } catch (error) {
    console.error('Resend OTP error:', error);
    throw error.response?.data || error;
  }
};

export const addBusToOwner = async (ownerId, busData, token) => {
  try {
    console.log('Owner ID received:', ownerId);
    console.log('Type of ownerId:', typeof ownerId);
    
    const url = addBusToOwnerApi(ownerId);
    console.log('Generated URL:', url);
    
    const response = await api.post(
      url, busData,
      {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error adding bus:', error);
    console.error('Error details:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

export const getAllBusownerAdminRoutes = async (token, page = 1, limit = 10, search = '', busOwnerId = '', filters = {}, localRouteName = '') => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search }),
      ...(busOwnerId && { busOwnerId }),
      ...(filters.originCity && { originCity: filters.originCity }),
      ...(filters.destinationCity && { destinationCity: filters.destinationCity }),
      ...(localRouteName && { localRouteName })
    });

    const response = await api.get(`${route_API}/busowner?${params}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching routes:', error);
    throw error;
  }
};

export const getAllSeatCategories = async (token, page = 1, pageSize = 10, search = '') => {
  try {
    const response = await api.get(`${getAllCategories}`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { page, limit: pageSize, search }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSeatCategoryById = async (id, token) => {
  try {
    const response = await api.get(`${getAllCategories}/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createSeatCategory = async (categoryData, token) => {
  try {
    const response = await api.post(`${getAllCategories}`, categoryData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateSeatCategory = async (id, categoryData, token) => {
  try {
    const response = await api.put(`${getAllCategories}/${id}`, categoryData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteSeatCategory = async (id, token) => {
  try {
    const response = await api.delete(`${getAllCategories}/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    console.log("response.data : ",response.data)
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getAllSeatLayouts = async (token, page = 1, pageSize = 10, search = '') => {
  try {
    const response = await api.get(`${getAllLayout}`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { page, limit: pageSize, search }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSeatLayoutById = async (id, token) => {
  try {
    const response = await api.get(`${getAllLayout}/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createSeatLayout = async (layoutData, token) => {
  try {
    const response = await api.post(`${getAllLayout}`, layoutData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateSeatLayout = async (id, layoutData, token) => {
  try {
    const response = await api.put(`${getAllLayout}/${id}`, layoutData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteSeatLayout = async (id, token) => {
  try {
    const response = await api.delete(`${getAllLayout}/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const previewSeatLayout = async (previewData, token) => {
  try {
    const response = await api.post(`${getAllLayout}/preview`, previewData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getLayoutsByCategory = async (categoryId, token) => {
  try {
    const response = await api.get(`${getAllLayout}/${categoryId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getAvailableConfigurations = async (token) => {
  try {
    const response = await api.get(`${getAllLayout}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getAllTerms = async (token, page = 1, limit = 10, type = "") => {
  try {
    const response = await api.get(`${getAllTerm}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      params: {
        page,
        limit,
        type
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching terms:', error);
    throw error;
  }
};
export const getTermsById = async (id, token) => {
  try {
    const response = await api.get(`${getAllTerm}/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching terms by ID:', error);
    throw error;
  }
};
export const getTermsByType = async (type, token) => {
  try {
    const response = await api.get(`${getAllTerm}/type/${type}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching terms by type:', error);
    throw error;
  }
};

export const createTerms = async (termsData, token) => {
  try {
    const response = await api.post(`${getAllTerm}`, termsData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating terms:', error);
    throw error;
  }
};

export const updateTerms = async (id, termsData, token) => {
  try {
    const response = await api.put(`${getAllTerm}/${id}`, termsData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating terms:', error);
    throw error;
  }
};

export const toggleTermsStatus = async (id, token) => {
  try {
    const response = await api.patch(`${getAllTerm}/${id}/toggle-status`, {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error toggling terms status:', error);
    throw error;
  }
};

export const getTermsHistory = async (id, token) => {
  try {
    const response = await api.get(`${getAllTerm}/${id}/history`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching terms history:', error);
    throw error;
  }
};

export const getAllRoutes = async (token, page = 1, limit = 10, search = "", origin = "", destination = "") => {
    try {
        const params = {
            page,
            limit
        };
        
        if (search) params.search = search;
        if (origin) params.origin = origin;
        if (destination) params.destination = destination;
        
        const response = await api.get(`${route_API}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            params
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching routes:', error);
        throw error;
    }
};

export const getRouteById = async (routeId, token) => {
  try {
    const response = await api.get(`${route_API}/${routeId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching route:', error);
    throw error;
  }
};
export const createRoute = async (routeData, token) => {
  try {
    const response = await api.post(`${route_API}`, routeData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating route:', error);
    throw error;
  }
};
export const updateRoute = async (routeId, routeData, token) => {
  try {
    const response = await api.put(`${route_API}/${routeId}`, routeData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating route:', error);
    throw error;
  }
};
export const updatePendingRoute = async (pendingId, routeData, token) => {
  try {
    const response = await api.put(`${route_API}/pending/${pendingId}`, routeData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating pending route:', error);
    throw error;
  }
};
export const deleteRoute = async (routeId, token) => {
  try {
    const response = await api.delete(`${route_API}/${routeId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting route:', error);
    throw error;
  }
};
export const toggleRouteStatus = async (routeId, isActive, token) => {
  try {
    const response = await api.patch(`${route_API}/${routeId}/status`, 
      { isActive },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error toggling route status:', error);
    throw error;
  }
};
export const getMasterRouteByName = async (masterRouteName, token) => {
  try {
    const response = await api.get(`${master_route_endpoint.masterRoutes_API}/name/${encodeURIComponent(masterRouteName)}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching master route by name:', error);
    throw error;
  }
};
export const getInfluencerCommissions = async (token, params = {}) => {
  try {
    const response = await api.get(getInfluencerCommissionsEndpoint, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error("GET_INFLUENCER_COMMISSIONS_API_ERROR", error);
    throw error;
  }
};



export const getCommissionStats = async (token, params = {}) => {
  try {
    const response = await api.get(getCommissionStatsEndpoint, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.log("GET_COMMISSION_STATS_API_ERROR..........", error);
    throw error;
  }
};

export const getCommissionById = async (id, token) => {
  try {
    console.log(`Fetching commission with ID: ${id}`);
    const response = await api.get(`${getCommissionByIdEndpoint}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Commission by ID Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_COMMISSION_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const processBulkPayout = async (data, token) => {
  try {
    console.log("Processing bulk payout...", data);
    const response = await api.post(`${processBulkPayoutEndpoint}`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Bulk Payout Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("PROCESS_BULK_PAYOUT_API_ERROR..........", error);
    throw error;
  }
};

export const getInfluencers = async (token, params = {}) => {
  try {
    console.log("Fetching influencers with params:", params);
    const response = await api.get(influencers_API, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Influencers API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_INFLUENCERS_API_ERROR..........", error);
    throw error;
  }
};

export const getInfluencerById = async (id, token) => {
  try {
    console.log(`Fetching influencer with ID: ${id}`);
    const response = await api.get(`${influencers_API}/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Influencer by ID Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_INFLUENCER_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const updateInfluencer = async (id, data, token) => {
  try {
    console.log(`Updating influencer with ID: ${id}`, data);
    const response = await api.put(`${influencers_API}/${id}`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Influencer Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_INFLUENCER_API_ERROR..........", error);
    throw error;
  }
};

export const deleteInfluencer = async (id, token) => {
  try {
    console.log(`Deleting influencer with ID: ${id}`);
    const response = await api.delete(`${influencers_API}/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Delete Influencer Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("DELETE_INFLUENCER_API_ERROR..........", error);
    throw error;
  }
};

export const updateInfluencerStatus = async (id, data, token) => {
  try {
    console.log(`Updating influencer status for ID: ${id}`, data);
    const response = await api.patch(`${influencers_API}/${id}/status`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Influencer Status Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_INFLUENCER_STATUS_API_ERROR..........", error);
    throw error;
  }
};

export const getAdminProfile = async (token) => {
  try {
    console.log("Fetching admin profile...");
    const response = await api.get(getAdminProfileEndpoint, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Admin Profile Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_ADMIN_PROFILE_API_ERROR..........", error);
    throw error;
  }
};

export const updateAdminProfile = async (data, token) => {
  try {
    console.log("Updating admin profile...", data);
    
    const isFormData = data instanceof FormData;
    
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    };

    if (!isFormData) {
      config.headers['Content-Type'] = 'application/json';
    }

    const response = await api.put(updateAdminProfileEndpoint, data, config);
    console.log("Update Admin Profile Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_ADMIN_PROFILE_API_ERROR..........", error);
    throw error;
  }
};

export const changeAdminPassword = async (data, token) => {
  try {
    console.log("Changing admin password...", data);
    const response = await api.put(changeAdminPasswordEndpoint, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Change Password Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("CHANGE_ADMIN_PASSWORD_API_ERROR..........", error);
    throw error;
  }
};

export const updateAdminSettings = async (data, token) => {
  try {
    console.log("Updating admin settings...", data);
    const response = await api.put(updateAdminSettingsEndpoint, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Admin Settings Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_ADMIN_SETTINGS_API_ERROR..........", error);
    throw error;
  }
};

export const getPayments = async (params, token) => {
  try {
    console.log("Fetching payments with params:", params);
    const response = await api.get(payments_API, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Payments API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_PAYMENTS_API_ERROR..........", error);
    throw error;
  }
};

export const getPaymentById = async (id, token) => {
  try {
    console.log(`Fetching payment with ID: ${id}`);
    const response = await api.get(getPaymentByIdEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Payment by ID Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_PAYMENT_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const processPayment = async (id, token) => {
  try {
    console.log(`Processing payment with ID: ${id}`);
    const response = await api.put(processPaymentEndpoint(id), {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Process Payment Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("PROCESS_PAYMENT_API_ERROR..........", error);
    throw error;
  }
};

export const refundPayment = async (id, refundData, token) => {
  try {
    console.log(`Refunding payment with ID: ${id}`, refundData);
    const response = await api.put(refundPaymentEndpoint(id), refundData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Refund Payment Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("REFUND_PAYMENT_API_ERROR..........", error);
    throw error;
  }
};

export const getCoupons = async (token, params = {}) => {
  try {
    console.log("Fetching coupons with params:", params);
    const response = await api.get(coupons_API, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Coupons API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_COUPONS_API_ERROR..........", error);
    throw error;
  }
};
export const getCouponById = async (id, token) => {
  try {
    console.log(`Fetching coupon with ID: ${id}`);
    const response = await api.get(getCouponByIdEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Coupon by ID Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_COUPON_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const createCoupon = async (data, token) => {
  try {
    console.log("Creating new coupon...", data);
    const response = await api.post(coupons_API, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Create Coupon Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("CREATE_COUPON_API_ERROR..........", error);
    throw error;
  }
};

export const updateCoupon = async (id, data, token) => {
  try {
    console.log(`Updating coupon with ID: ${id}`, data);
    const response = await api.put(updateCouponEndpoint(id), data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Coupon Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_COUPON_API_ERROR..........", error);
    throw error;
  }
};

export const deleteCoupon = async (id, token) => {
  try {
    console.log(`Deleting coupon with ID: ${id}`);
    const response = await api.delete(deleteCouponEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Delete Coupon Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("DELETE_COUPON_API_ERROR..........", error);
    throw error;
  }
};


export const getBusOwners = async (token, page = 1, limit = 10, search = "") => {
  try {
    const response = await api.get(busOwners_API, {
      params: { 
        page,
        limit,
        search
      },
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.log("GET_BUS_OWNERS_API_ERROR..........", error);
    throw error;
  }
};

export const getBookingsByDateAndBus = async (token, busId, date) => {
  try {
    console.log('📡 Calling API with:', { busId, date });
    
    const response = await api.get(bookingFilter_API, {
      params: {
        busId: busId,
        date: date
      },
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log('📦 API Response:', response.data);
    return response.data;
  } catch (error) {
    console.log("GET_BOOKINGS_BY_DATE_API_ERROR..........", error);
    console.error('Error details:', error.response?.data || error.message);
    throw error;
  }
};

export const getBusSeatAvailability = async (token, busId, date, direction, timeSlot) => {
  try {
    console.log('📡 Calling seat availability API with:', { busId, date, direction, timeSlot });
    
    const response = await api.get('/bus-seat-availability', {
      params: {
        busId: busId,
        date: date,
        direction: direction,
        timeSlot: timeSlot || 1
      },
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log('📦 Seat availability response:', response.data);
    return response.data;
  } catch (error) {
    console.log("GET_SEAT_AVAILABILITY_API_ERROR..........", error);
    console.error('Error details:', error.response?.data || error.message);
    throw error;
  }
};

export const getBusOwnerById = async (id, token) => {
  try {
    console.log(`Fetching bus owner with ID: ${id}`);
    const response = await api.get(getBusOwnerByIdEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Bus Owner by ID Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_BUS_OWNER_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const approveBusOwner = async (id, token) => {
  try {
   console.log("token : ", token);
    const response = await api.patch(approvedBusOwnerById(id), 
      {}, 
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error approving bus owner:', error);
    throw error;
  }
};

export const createBusOwner = async (data, token) => {
  try {
    console.log("Creating new bus owner...", data);
    const response = await api.post(busOwners_API, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Create Bus Owner Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("CREATE_BUS_OWNER_API_ERROR..........", error);
    throw error;
  }
};
export const updateBusOwner = async (id, data, token) => {
  try {
    console.log(`Updating bus owner with ID: ${id}`, data);
    
    const response = await api.put(`/bus-owners/${id}`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log("Update Bus Owner Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("UPDATE_BUS_OWNER_API_ERROR..........", error);
    throw error;
  }
};

export const updatePendingBusOwner = async (id, data, token) => {
  try {
    console.log(`Updating pending bus owner with ID: ${id}`, data);
    
    const response = await api.put(`/bus-owners/pending/${id}`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log("Update Pending Bus Owner Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("UPDATE_PENDING_BUS_OWNER_API_ERROR..........", error);
    throw error;
  }
};

export const deleteBusOwner = async (id, token) => {
  try {
    console.log(`Deleting bus owner with ID: ${id}`);
    const response = await api.delete(deleteBusOwnerEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Delete Bus Owner Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("DELETE_BUS_OWNER_API_ERROR..........", error);
    throw error;
  }
};

export const getCustomers = async (token, page = 1, limit = 10, search = "") => {
  try {
    const response = await api.get(customersEndpoint, {
      params: { 
        page,
        limit,
        search
      },
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCustomerById = async (id, token) => {
  try {
    console.log(`Fetching customer with ID: ${id}`);
    const response = await api.get(getCustomerByIdEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Customer by ID Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_CUSTOMER_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const updateCustomer = async (id, data, token) => {
  try {
    console.log(`Updating customer with ID: ${id}`, data);
    const response = await api.put(updateCustomerEndpoint(id), data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Customer Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_CUSTOMER_API_ERROR..........", error);
    throw error;
  }
};

export const login_data = async (data) => {
  try {
    console.log("Login API Call Started...");
    const response = await api.post(login_API, data);
    console.log("Login API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_login_API_ERROR..........", error);
    throw error;
  }
};

export const getDashboardStats = async (token) => {
  try {
    console.log("Dashboard Stats API Call Started...");
    const response = await api.get(dashboard_API, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    console.log("Dashboard Stats API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_dashboard_API_ERROR..........", error);
    throw error;
  }
};

export const getUsers = async (token) => {
  try {
    console.log("Users API Call Started...");
    const response = await api.get(users_API, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    console.log("Users API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_users_API_ERROR..........", error);
    throw error;
  }
};

export const getDrivers = async (token, page = 1, limit = 10, search = '') => {
  try {
    console.log("Drivers API Call Started...");
    
    const params = {};
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (search) params.search = search;
    
    const response = await api.get(drivers_API, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      params: params
    });
    
    console.log("Drivers API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_drivers_API_ERROR..........", error);
    throw error;
  }
};

export const getConductors = async (token, page = 1, limit = 10, search = '') => {
  try {
      const params = {};
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (search) params.search = search;
    
    console.log("Conductors API Call Started...");
    const response = await api.get(conductors_API, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      params: params
    });
    console.log("Conductors API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_conductors_API_ERROR..........", error);
    throw error;
  }
};

export const getDriverById = async (id, token) => {
  try {
    console.log(`Fetching driver with ID: ${id}`);
    const response = await api.get(`${drivers_API}/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    console.log("Driver Details Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_driver_by_ID_API_ERROR..........", error);
    throw error;
  }
};

export const updateDriver = async (id, driverData, token) => {
  try {
    console.log(`Updating driver with ID: ${id}`, driverData);
    const response = await api.put(`${drivers_API}/${id}`, driverData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Driver Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_driver_API_ERROR..........", error);
    throw error;
  }
};

export const updatePendingDriver = async (id, driverData, token) => {
  try {
    console.log(`Updating pending driver with ID: ${id}`, driverData);
    const response = await api.put(`${drivers_API}/pending/${id}`, driverData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Pending Driver Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_PENDING_DRIVER_API_ERROR..........", error);
    throw error;
  }
};

export const getConductorById = async (id, token) => {
  try {
    console.log(`Fetching conductor with ID: ${id}`);
    const response = await api.get(`${conductors_API}/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    console.log("Conductor Details Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_conductor_by_ID_API_ERROR..........", error);
    throw error;
  }
};

export const updateConductor = async (id, conductorData, token) => {
  try {
    console.log(`Updating conductor with ID: ${id}`, conductorData);
    const response = await api.put(`${conductors_API}/${id}`, conductorData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Conductor Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_conductor_API_ERROR..........", error);
    throw error;
  }
};

export const updatePendingConductor = async (id, conductorData, token) => {
  try {
    console.log(`Updating pending conductor with ID: ${id}`, conductorData);
    const response = await api.put(`${conductors_API}/pending/${id}`, conductorData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Pending Conductor Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_PENDING_CONDUCTOR_API_ERROR..........", error);
    throw error;
  }
};

export const getBookings = async (token, params = {}) => {
  try {
    const response = await api.get(bookings_API, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.log("GET_BOOKINGS_API_ERROR..........", error);
    throw error;
  }
};

export const getBookingById = async (id, token) => {
  try {
    console.log(`Fetching booking with ID: ${id}`);
    const response = await api.get(getBookingByIdEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Booking by ID Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_BOOKING_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const updateBooking = async (id, data, token) => {
  try {
    console.log(`Updating booking with ID: ${id}`, data);
    const response = await api.put(updateBookingEndpoint(id), data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Booking Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_BOOKING_API_ERROR..........", error);
    throw error;
  }
};

export const updateBookingStatus = async (id, statusData, token) => {
  try {
    console.log(`Updating booking status for ID: ${id}`, statusData);
    const response = await api.patch(updateBookingStatusEndpoint(id), statusData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Booking Status Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_BOOKING_STATUS_API_ERROR..........", error);
    throw error;
  }
};

export const getCommissionReports = async (params, token) => {
  try {
    console.log("Fetching commission reports with params:", params);
    const response = await api.get(getCommissionReportsEndpoint, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Commission Reports Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("GET_COMMISSION_REPORTS_API_ERROR..........", error);
    throw error;
  }
};

export const getBusOwnerCommission = async (id, token) => {
  try {
    console.log(`Fetching commission for bus owner ID: ${id}`);
    const response = await api.get(getBusOwnerCommissionEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Bus Owner Commission Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("GET_BUS_OWNER_COMMISSION_API_ERROR..........", error);
    throw error;
  }
};

export const updateBusOwnerCommission = async (id, commissionData, token) => {
  try {
    console.log(`Updating commission for bus owner ID: ${id}`, commissionData);
    const response = await api.put(updateBusOwnerCommissionEndpoint(id), commissionData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Commission Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("UPDATE_BUS_OWNER_COMMISSION_API_ERROR..........", error);
    throw error;
  }
};

export const processCommissionPayout = async (id, payoutData, token) => {
  try {
    console.log(`Processing payout for bus owner ID: ${id}`, payoutData);
    const response = await api.post(processCommissionPayoutEndpoint(id), payoutData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Process Payout Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("PROCESS_COMMISSION_PAYOUT_API_ERROR..........", error);
    throw error;
  }
};

export const createInfluencer = async (data, token) => {
  try {
    console.log("Creating new influencer...", data);
    const response = await api.post(influencers_API, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Create Influencer Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("CREATE_INFLUENCER_API_ERROR..........", error);
    throw error;
  }
};

export const getRouteActivityLogs = async (routeId, token, page = 1, limit = 20) => {
  try {
    const response = await api.get(
      `/activity-logs/routes/${routeId}/logs`,
      {
        params: { page, limit, sort: '-createdAt' },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching route activity logs:', error);
    throw error;
  }
};

export const getBusActivityLogs = async (busId, token, page = 1, limit = 20) => {
  try {
    const response = await api.get(
      `/buses/${busId}/logs`,
      {
        params: { page, limit, sort: '-createdAt' },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching bus activity logs:', error);
    throw error;
  }
};

export const getOwnerPaymentLogs = async (ownerId, token, page = 1, limit = 20, status = '') => {
  try {
    const params = { page, limit, sort: '-createdAt' };
    if (status) params.status = status;
    
    const response = await api.get(
      `/activity-logs/payments/owner/${ownerId}`,
      {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching owner payment logs:', error);
    throw error;
  }
};

export const getEntityActivityLogs = async (entityType, entityId, token, page = 1, limit = 20) => {
  try {
    const response = await api.get(
      `/activity-logs/${entityType}/${entityId}`,
      {
        params: { page, limit, sort: '-createdAt' },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching entity activity logs:', error);
    throw error;
  }
};

export const getPendingBusOwners = async (token) => {
  try {
    const response = await api.get(
      `/pending/busowner`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching pending bus owners:', error);
    throw error;
  }
};

export const approvePendingBusOwner = async (pendingId, token) => {
  try {
    const response = await api.post(
      `/pending/busowner/${pendingId}/approve`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error approving pending bus owner:', error);
    throw error;
  }
};

export const rejectPendingBusOwner = async (pendingId, token) => {
  try {
    const response = await api.post(
      `/pending/busowner/${pendingId}/reject`,
      { rejectionReason: 'Rejected by admin' },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error rejecting pending bus owner:', error);
    throw error;
  }
};

export const getPendingDrivers = async (token) => {
  try {
    const response = await api.get(
      `/pending/driver`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching pending drivers:', error);
    throw error;
  }
};

export const approvePendingDriver = async (pendingId, token) => {
  try {
    const response = await api.post(
      `/pending/driver/${pendingId}/approve`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error approving pending driver:', error);
    throw error;
  }
};

export const rejectPendingDriver = async (pendingId, token) => {
  try {
    const response = await api.post(
      `/pending/driver/${pendingId}/reject`,
      { rejectionReason: 'Rejected by admin' },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error rejecting pending driver:', error);
    throw error;
  }
};

export const getPendingConductors = async (token) => {
  try {
    const response = await api.get(
      `/pending/conductor`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching pending conductors:', error);
    throw error;
  }
};

export const approvePendingConductor = async (pendingId, token) => {
  try {
    const response = await api.post(
      `/pending/conductor/${pendingId}/approve`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error approving pending conductor:', error);
    throw error;
  }
};

export const rejectPendingConductor = async (pendingId, token) => {
  try {
    const response = await api.post(
      `/pending/conductor/${pendingId}/reject`,
      { rejectionReason: 'Rejected by admin' },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error rejecting pending conductor:', error);
    throw error;
  }
};

export const getPendingBuses = async (token) => {
  try {
    const response = await api.get(
      `/pending/bus`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching pending buses:', error);
    throw error;
  }
};

export const approvePendingBus = async (pendingId, token) => {
  try {
    const response = await api.post(
      `/pending/bus/${pendingId}/approve`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error approving pending bus:', error);
    throw error;
  }
};

export const rejectPendingBus = async (pendingId, token) => {
  try {
    const response = await api.post(
      `/pending/bus/${pendingId}/reject`,
      { rejectionReason: 'Rejected by admin' },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error rejecting pending bus:', error);
    throw error;
  }
};

export const getPendingRoutes = async (token) => {
  try {
    const response = await api.get(
      `/pending/route`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching pending routes:', error);
    throw error;
  }
};

export const approvePendingRoute = async (pendingId, token) => {
  try {
    const response = await api.post(
      `/pending/route/${pendingId}/approve`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error approving pending route:', error);
    throw error;
  }
};

export const rejectPendingRoute = async (pendingId, token) => {
  try {
    const response = await api.post(
      `/pending/route/${pendingId}/reject`,
      { rejectionReason: 'Rejected by admin' },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error rejecting pending route:', error);
    throw error;
  }
};

export const getPendingDriverById = async (id, token) => {
  try {
    const response = await api.get(
      `/pending/driver/${id}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching pending driver by ID:', error);
    throw error;
  }
};

export const getPendingConductorById = async (id, token) => {
  try {
    const response = await api.get(
      `/pending/conductor/${id}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching pending conductor by ID:', error);
    throw error;
  }
};

export const getPendingBusOwnerById = async (id, token) => {
  try {
    const response = await api.get(
      `/pending/busowner/${id}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching pending bus owner by ID:', error);
    throw error;
  }
};

export const getPendingBusById = async (id, token) => {
  try {
    const response = await api.get(
      `/pending/bus/${id}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching pending bus by ID:', error);
    throw error;
  }
};

export const getPendingRouteById = async (id, token) => {
  try {
    const response = await api.get(
      `/pending/route/${id}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching pending route by ID:', error);
    throw error;
  }
};

export const getBusReport = async (busId, token, startDate, endDate) => {
  try {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    const response = await api.get(
      `/bus-report/${busId}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        params: params
      }
    );
   
    return response.data;
  } catch (error) {
    console.error('Error fetching bus report:', error);
    throw error;
  }
};

export const getAllBusesReport = async (token, startDate, endDate, ownerId) => {
  try {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (ownerId) params.ownerId = ownerId;

    const response = await api.get(
      `/bus-report`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        params: params
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching all buses report:', error);
    throw error;
  }
};

export const getBusOwnerReport = async (ownerId, token, startDate, endDate) => {
  try {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    const response = await api.get(
      `/bus-owner-report/${ownerId}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        params: params
      }
    );
   
    return response.data;
  } catch (error) {
    console.error('Error fetching bus owner report:', error);
    throw error;
  }
};

// export const getAllBusOwnersReport = async (token, startDate, endDate, ownerId = null) => {
//   try {
//     const params = {};
//     if (startDate) params.startDate = startDate;
//     if (endDate) params.endDate = endDate;
//     if (ownerId)
//       params.ownerId = ownerId;

//     const response = await api.get(
//       `/bus-owner-report`,
//       {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//         params: params
//       }
//     );
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching all bus owners report:', error);
//     throw error;
//   }
// };

// Update the API service function
export const getAllBusOwnersReport = async (token, startDate, endDate, ownerId = null, page = 1, limit = 10, search = '') => {
  try {
    const params = {
      page: page,
      limit: limit
    };
    
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (ownerId) params.ownerId = ownerId;
    if (search && search.trim() !== '') params.search = search;

    const response = await api.get(
      `/bus-owner-report`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        params: params
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching all bus owners report:', error);
    throw error;
  }
};

export const approveUser = async (userId, userType, token) => {
  try {
    const response = await api.put(
      `/approve-user/${userId}`,
      { type: userType },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error approving user:', error);
    throw error;
  }
};

export const rejectUser = async (userId, userType, token) => {
  try {
    const response = await api.delete(
      `/reject-user/${userId}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        data: { type: userType }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error rejecting user:', error);
    throw error;
  }
};